import {USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE} from './Index';

// REDUX ACTION TO STORE USER HAVE ADMIN ROLE AND REPORTS ENABLE PERMISSION
export const _setUserHasAdminRoleAndReportsEnable = (
  user_has_admin_role_and_reports_enable: boolean
): any => async (dispatch: any) => {
  dispatch({
    type: USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE,
    payload: {user_has_admin_role_and_reports_enable}
  });
};
